import { useReducer, useEffect } from 'react';

const initialState = [
    true,
    undefined,
    undefined,
    false
];
function reducer(state, action) {
    switch(action.type){
        case 'RESET':
            return initialState;
        case 'CALLED':
            return [
                true,
                undefined,
                undefined,
                true
            ];
        case 'SUCCESS':
            return [
                false,
                action.payload,
                undefined,
                true
            ];
        case 'FAILURE':
            return [
                false,
                undefined,
                action.payload,
                true
            ];
    }
}
/**
 * Use one of the api-client's functions as a hook. The first argument is the
 * API function itself. The rest of the argument are the API function's
 * parameters.
 *
 * For example:
 *
 *    const [loading, result, error] = useApiClient(
 *      Orders.list,
 *      apiUrl,
 *      accessToken,
 *      { customerId, limit, offset }
 *    )
 *
 *  Note: the type of the rest arguments and of `result` are inferred from the
 *  given API function.
 */ function useApiClient(apiFunc, options, ...params) {
    const [state, dispatch] = useReducer(reducer, initialState);
    useEffect(()=>{
        let cancelled = false;
        dispatch({
            type: 'RESET'
        });
        if (options && options.skip) {
            return;
        }
        dispatch({
            type: 'CALLED'
        });
        apiFunc(...params) // TODO: Currently, `any` is required because of skip functionality
        .then((result)=>cancelled || dispatch({
                type: 'SUCCESS',
                payload: result
            })
        ).catch((error)=>cancelled || dispatch({
                type: 'FAILURE',
                payload: error
            })
        );
        return ()=>{
            cancelled = true;
        };
    }, [
        options && options.skip,
        ...params
    ]);
    return state;
}

export { useApiClient };
//# sourceMappingURL=use-api-client.js.map
